import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";

import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { TUserConsumablesData } from "../../Types";

export const apiCallGetUserConsumables = async ({
  userID
}: {
  userID: number;
}): Promise<{
  data: TUserConsumablesData;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TUserConsumablesData>(
    `user/getUserConsumables`,
    {
      userID
    }
  );

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: {
        boostNextRenewalDate: data.boostNextRenewalDate,
        rewindNextRenewalDate: data.rewindNextRenewalDate,
        readReceiptNextRenewalDate: data.readReceiptNextRenewalDate,
        chatWeeklyNextRenewalDate: data.chatWeeklyNextRenewalDate,
        chatDailyNextRenewalDate: data.chatDailyNextRenewalDate,
        payingBoostPackageUntil: data.payingBoostPackageUntil,
        payingRewindPackageUntil: data.payingRewindPackageUntil,
        meteredBoostCount: data.meteredBoostCount,
        quotaBoostCount: data.quotaBoostCount,
        meteredRewindCount: data.meteredRewindCount,
        quotaRewindCount: data.quotaRewindCount,
        meteredReadReceiptCount: data.meteredReadReceiptCount,
        quotaReadReceiptCount: data.quotaReadReceiptCount,
        meteredChatWeeklyCount: data.meteredChatWeeklyCount,
        meteredChatDailyCount: data.meteredChatDailyCount
      },
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        boostNextRenewalDate: "",
        rewindNextRenewalDate: "",
        readReceiptNextRenewalDate: "",
        chatWeeklyNextRenewalDate: "",
        chatDailyNextRenewalDate: "",
        payingBoostPackageUntil: "",
        payingRewindPackageUntil: "",
        meteredBoostCount: "",
        quotaBoostCount: "",
        meteredRewindCount: "",
        quotaRewindCount: "",
        meteredReadReceiptCount: "",
        quotaReadReceiptCount: "",
        meteredChatWeeklyCount: "",
        meteredChatDailyCount: ""
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        boostNextRenewalDate: "",
        rewindNextRenewalDate: "",
        readReceiptNextRenewalDate: "",
        chatWeeklyNextRenewalDate: "",
        chatDailyNextRenewalDate: "",
        payingBoostPackageUntil: "",
        payingRewindPackageUntil: "",
        meteredBoostCount: "",
        quotaBoostCount: "",
        meteredRewindCount: "",
        quotaRewindCount: "",
        meteredReadReceiptCount: "",
        quotaReadReceiptCount: "",
        meteredChatWeeklyCount: "",
        meteredChatDailyCount: ""
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
